function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("g", {
  id: "_2491258819328"
}, /*#__PURE__*/React.createElement("path", {
  d: "M149 19l0 378c0,13 5,20 19,20l81 0c14,0 19,-7 19,-20l0 -378c0,-15 -7,-19 -20,-19l-80 0c-14,0 -19,6 -19,19z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M308 120c-15,6 -10,24 -10,43l0 208c0,16 -4,39 8,44 6,3 94,3 102,0 13,-5 9,-26 9,-42l0 -209c0,-16 4,-37 -9,-43 -5,-3 -93,-3 -100,-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 184l0 213c0,14 5,20 20,20l79 0c15,0 20,-5 20,-20l0 -213c0,-14 -5,-20 -20,-20l-79 0c-16,0 -20,5 -20,20z"
})));

var SvgStatistics = function SvgStatistics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatistics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/statistics.b809d347.svg";
export { ForwardRef as ReactComponent };